import Super from '../../core/button.gjs';
import styles from './destructive.module.scss';

export default class SpdsActionButtonDestructive extends Super {
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-destructive';
  variantStyles = styles;
}
